import squareGrid from "./square-grid.html";
import "./square-grid.css";

export default squareGrid;
